import { Button, Result } from "antd";
import { useNavigate } from "react-router-dom";

export function NotFound(): JSX.Element {
  const navigate = useNavigate();
  return (
    <Result
      status="404"
      title="没有这个页面"
      subTitle="请从左侧菜单进入工作台。"
      extra={<Button type="primary" onClick={() => navigate("/")}>回到总览</Button>}
    />
  );
}

export function Forbidden(): JSX.Element {
  const navigate = useNavigate();
  return (
    <Result
      status="403"
      title="这个账号不能打开这一页"
      subTitle="请让主管或管理员处理，或回到总览看你能做的事。"
      extra={<Button type="primary" onClick={() => navigate("/")}>回到总览</Button>}
    />
  );
}
